import { forwardRef, useRef } from "react";
import { useEffect } from "react";
import { useInView } from "react-intersection-observer";

const withOnboardingItem = (Component: React.ComponentType<any>) => {
  return forwardRef(
    (
      {
        handleSlideChange,
        slid,
        index,
        image,
        title,
        description,
        ...props
      }: {
        handleSlideChange: (index: number) => void;
        slid: number;
        index: number;
        image: string;
        title: string;
        description: string;
      },
      ref: any,
    ) => {
      const { ref: inViewRef, inView } = useInView();
      const scrollRef = useRef<HTMLDivElement>(null);

      useEffect(() => {
        if (inView) {
          handleSlideChange(index);
        }
      }, [inView]);

      useEffect(() => {
        if (slid === index && !inView) {
          scrollRef.current?.scrollIntoView();
        }
      }, [slid]);

      return (
        <Component
          ref={ref}
          scrollRef={scrollRef}
          inViewRef={inViewRef}
          image={image}
          title={title}
          description={description}
          {...props}
        />
      );
    },
  );
};

export default withOnboardingItem;
